
import { ShopSettings } from '../../services/ShopSettings';
import CardAddressStoreLocator from './components/CardAddressStoreLocator.vue';
import { SearchIcon, XIcon } from 'vue-feather-icons';
export default {
  layout: 'MainLayout',
  auth: false,
  components: {
    CardAddressStoreLocator,
    SearchIcon,
    XIcon,
  },
  data: () => ({
    term: '',
    points: [],
    selectedPoint: null,
    allPoints: [],
  }),
  computed: {
    pointsClickAndCollectMap() {
      const pts = this.points.length ? this.points : this.allPoints;
      return pts.map((point) => {
        return {
          id: point.IdStore,
          latitude: point.Latitude,
          longitude: point.Longitude,
        };
      });
    },
  },
  methods: {
    selectAddress(address) {
      this.loadStores({
        Latitude: address.latitude,
        Longitude: address.longitude,
        Radius: 100,
      });
    },
    async loadStores({ Latitude, Longitude, Radius }) {
      const shopSettings = new ShopSettings(this.$http, this.$store);
      try {
        this.points = await shopSettings.stores({
          Latitude,
          Longitude,
          Radius,
          LanguageIsoCode: this.$i18n.locale,
        });
        this.selectedPoint = {
          id: this.points[0].IdStore,
          latitude: this.points[0].Latitude,
          longitude: this.points[0].Longitude,
        };
        if (!this.allPoints.length) {
          this.allPoints = this.points;
        }
      } catch (error) {}
    },
  },
  mounted() {
    this.loadStores({
      Latitude: 48.8606104,
      Longitude: 2.3391758,
      Radius: 1000,
    });
    if (process.client) {
      window.scrollTo(0, 0);
    }
  },
};
